import React from 'react';
import { graphql } from 'react-apollo';

import authService from '../../state/services/auth';
import { GQLQueryPropType } from '../../proptypes';
import { UserQueryPrivate, UserQueryPublicBasic } from '../../state/services/gql/user';

import UserMenu from '../../components/UserMenu';

/**
 * User menu container component.
 * Wraps the user menu presentational component with Redux state.
 */
const UserMenuContainer = (props) => {
  const {
    data,
    ...otherProps
  } = props;
  return (
    <UserMenu profile={data && data.profile} {...otherProps} />
  );
};

UserMenuContainer.propTypes = {
  /**
   * Data object from GraphQL query containing form.
   */
  data: GQLQueryPropType,
};


UserMenuContainer.defaultProps = {
  data: {},
};

export default (props) => {
  const UserMenuContainerWithGraphQL = graphql(
    authService.loggedIn() ? UserQueryPrivate : UserQueryPublicBasic,
    {
      options: { variables: { id: authService.getUserCookie() } },
      skip: !authService.getUserCookie(),
    },
  )(
    UserMenuContainer,
  );

  return <UserMenuContainerWithGraphQL {...props} />;
};



// WEBPACK FOOTER //
// ./app/src/containers/UserMenu/index.jsx